import type { EmployeeDesignation } from '../types';
import { hasFullCrmEmployeeAccess, hasOfficeOpsPrivileges } from './employeeDesignations';

/** EA, Office Manager, or admin may create content requests. */
export function canCreateMarketingRequest(args: {
  authRole: string | undefined;
  designations: EmployeeDesignation[] | string[] | undefined;
}): boolean {
  if (args.authRole === 'admin') return true;
  return hasOfficeOpsPrivileges(args.designations);
}

/** Marketing Hub gate — full CRM employees (incl. Office Manager). */
export function canAccessMarketingRequests(
  authRole: string | undefined,
  designations?: EmployeeDesignation[] | string[],
): boolean {
  return hasFullCrmEmployeeAccess({ authRole, designations });
}
